/* Tildas redesign: draws the chosen frame around the configurators' live preview (canvas boards
   Bouquet, SingleFlower, BirthPoster). It only reads the frame add-on's selection
   (window.TBPFrame, assets/frame-addon.js) and sets data-tb-frame on the preview; the drawing is
   CSS in assets/tb-configurator.css. Nothing in the order flow reads this. */
// Opens Dawn's cart drawer with fresh contents after a configurator added to the cart (they used to
// fall back to the full cart page when the theme has no cart notification). Global on purpose: the
// configurator scripts call window.tbOpenCartDrawer() when it exists.
window.tbOpenCartDrawer = function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
  fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      drawer.classList.remove('is-empty');
      drawer.renderContents({ sections: sections });
    })
    .catch(function () { window.location.href = '/cart'; });
};

(function () {
  // the live previews, plus the small floating previews the configurators show on phones
  var WRAPS = '.fb-canvas-wrap, .sfp-canvas-wrap, .bp-canvas-wrap, .fb-mini, .bp-mini-preview';

  function frameKind(label) {
    var l = String(label || '').toLowerCase();
    if (!l) return '';
    if (/mörk|mork|dark|dunkel/.test(l)) return 'dark';
    if (/svart|black|schwarz/.test(l)) return 'black';
    if (/vit\b|vit |white|weiß|weiss/.test(l) || l === 'vit') return 'white';
    if (/\bek\b|ek |oak|eiche|trä|wood|holz/.test(l)) return 'oak';
    return 'oak';
  }

  function apply() {
    var wraps = document.querySelectorAll(WRAPS);
    if (!wraps.length) return;
    var sel = window.TBPFrame && typeof window.TBPFrame.getSelection === 'function' ? window.TBPFrame.getSelection() : null;
    var kind = sel ? frameKind(sel.colorLabel) : '';
    wraps.forEach(function (w) {
      if (kind) w.setAttribute('data-tb-frame', kind);
      else w.removeAttribute('data-tb-frame');
    });
  }

  var hooked = false;
  function hook() {
    if (hooked || !window.TBPFrame || typeof window.TBPFrame.onChange !== 'function') return;
    hooked = true;
    window.TBPFrame.onChange(apply);
    apply();
  }

  function boot() {
    if (!document.querySelector(WRAPS)) return;
    hook();
    if (!hooked) window.addEventListener('load', hook, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Phone mini preview (bouquet, vase, personalised birth poster): a tap scrolls up to the full preview,
   and the mini is replaced by a "back to editing" button in the same corner that returns to the exact
   spot. The bouquet and vase already have that button (#fb-mini-return, styled in tb-configurator.css);
   the birth poster gets one here. Scrolling lands clear of the sticky header (scroll-margin-top in CSS). */
(function () {
  function bootBirthReturn() {
    var mini = document.getElementById('bp-mini-preview');
    var wrap = document.querySelector('.bp-canvas-wrap');
    if (!mini || !wrap || mini.dataset.tbReturn || !('IntersectionObserver' in window)) return;
    mini.dataset.tbReturn = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fb-return tb-mini-return';
    btn.setAttribute('aria-hidden', 'true');
    btn.textContent = '\u2193\u00a0' + (mini.getAttribute('data-tb-return') || document.documentElement.getAttribute('data-tb-return') || '');
    document.body.appendChild(btn);
    var savedY = null;
    // runs before the configurator's own handler, which scrolls the preview to the centre
    mini.addEventListener('click', function () {
      savedY = window.scrollY || window.pageYOffset || 0;
      setTimeout(function () { wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
    }, true);
    btn.addEventListener('click', function () {
      window.scrollTo({ top: savedY != null ? savedY : 0, behavior: 'smooth' });
    });
    new IntersectionObserver(function (entries) {
      var show = entries[0].isIntersecting && savedY != null;
      btn.classList.toggle('is-visible', show);
      btn.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0.15 }).observe(wrap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootBirthReturn);
  else bootBirthReturn();
})();
